import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";

const Login = ({ setAutenticado }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);
  const navigate = useNavigate();

  // Detectar si estamos en desarrollo o producción
  const API_URL = process.env.NODE_ENV === 'production' 
    ? 'https://erp-secretaria.onrender.com' 
    : 'http://localhost:5000';

  const manejarSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setCargando(true);

    console.log("Intentando conectar a:", `${API_URL}/login`);
    console.log("Credenciales:", { username, password: "***" });

    try {
      const response = await fetch(`${API_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      console.log("Response status:", response.status);

      const data = await response.json();
      console.log("Response data:", data);

      if (response.ok) {
        // Guardar el token en localStorage
        localStorage.setItem("token", data.token);
        localStorage.setItem("usuario", data.usuario);
        
        // Actualizar el estado de autenticación
        setAutenticado(true);
        
        // Pequeño delay para asegurar que el estado se actualice
        setTimeout(() => {
          navigate("/");
          window.location.reload(); // Forzar recarga para actualizar el estado
        }, 100);
      } else {
        setError(data.error || "Error al iniciar sesión");
      }
    } catch (error) {
      console.error("Error completo:", error);
      setError(`Error de conexión: ${error.message}. Verifica que el servidor backend esté corriendo en el puerto 5000.`);
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <img
            src="/logo_movimonte_nuevo.png"
            alt="Logo Movimonte"
            className="login-logo"
          />
          <h2>Sistema ERP Movimonte</h2>
          <p>Ingrese sus credenciales</p>
        </div>

        <form onSubmit={manejarSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Usuario</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
              placeholder="Ingrese su usuario"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              placeholder="Ingrese su contraseña"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="login-button" disabled={cargando}>
            {cargando ? "Iniciando sesión..." : "Iniciar Sesión"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
